export default (content) => {
    
    // console.log("content check start");
    
    
    let html = $("<div class='article-parse'>"+content+"</div>");
    
    // console.log(html.find(".h-card").length);
    
    html.find(".h-card").each(function(a,b){
        
    //     // let beforeH2 = $(this).html();;
    //     // let beforeH3 = $(this).prev("h3");
    //     // 
    //     // console.log("this html", a, $(this).prev().parent().html())
        
    //     // console.log("content" ,a , beforeH2.text(), beforeH3.text(),$(this).text())
    
    // console.log($(this).parent());
    
    $(this).prev("h2").text()
    
    if($(this).prev("h2").length){
        // console.log($(this).prev("h2").text());
        let hcard = $(this).prop("outerHTML");
        
        hcard = hcard.replace(/h5/gmi, "h6");
        hcard = hcard.replace(/h4/gmi, "h5");
        hcard = hcard.replace(/h3/gmi, "h4");
        hcard = hcard.replace(/h2/gmi, "h3");
        
        if($(this).find("h2,h3").length){
            // console.log("this prev hs h2", $(this).prev("h2").text(), hcard)
        }
        
        
        // console.log(hcard)
        $(this).html(hcard);
        
    }
        
        
        
        
    })
    
    html = html.html();
    
    // html
    
    // console.log("content check end");
    
    return html;
    
}